/**
 * RecrawlPage – Eigenständige Seite für den Re-Crawl (statt Tab in Admin)
 */
import RecrawlTab from '@/components/admin/RecrawlTab';
import { RefreshCw } from 'lucide-react';

export default function RecrawlPage() {
  return (
    <div className="p-6 max-w-7xl mx-auto" data-testid="recrawl-page">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-3">
          <RefreshCw className="w-6 h-6" />
          Re-Crawl
        </h1>
        <p className="text-slate-500 mt-1">Aktenübernahme neu verarbeiten</p>
      </div>
      <RecrawlTab />
    </div>
  );
}
